// extracted by mini-css-extract-plugin
module.exports = {"customCheckbox":"CustomCheckbox_customCheckbox__1H-9x","inputCheckbox":"CustomCheckbox_inputCheckbox__2p5Ys"};